import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Lock } from 'lucide-react';
import { Button } from '../ui/Button';
export const FooterOfferSection = () => {
  return <section className="py-16 px-4 bg-black border-t-4 border-orange-500" data-id="element-115">
      <div className="max-w-4xl mx-auto text-center" data-id="element-116">
        <div className="mb-12" data-id="element-117">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-118">
            🏆 COMBO RECOMENDADO
          </h3>
          <p className="text-xl text-orange-500 font-bold mb-4" data-id="element-119">
            Cocina Resuelta + Postres
          </p>
          <p className="text-gray-500 line-through mb-1" data-id="element-120">Antes: $76.900</p>
          <p className="text-orange-500 font-bold uppercase tracking-widest text-sm mb-1" data-id="element-121">
            Hoy
          </p>
          <p className="text-5xl font-extrabold text-white mb-6" data-id="element-122">
            $27.990 <span className="text-xl text-gray-400" data-id="element-123">ARS</span>
          </p>
          <div className="max-w-xl mx-auto" data-id="element-124">
            <Button href="https://www.compradigitalya.com/cart/42853226315847:1" className="shadow-[0_0_20px_rgba(249,115,22,0.4)]" data-id="element-125">
              👉 QUIERO EL COMBO COMPLETO CON POSTRES
            </Button>
          </div>
        </div>

        <div className="mb-12 pt-12 border-t border-gray-800" data-id="element-126">
          <h3 className="text-xl font-bold text-gray-300 mb-4" data-id="element-127">
            📘 SOLO COCINA RESUELTA
          </h3>
          <p className="text-gray-500 line-through mb-1" data-id="element-128">Antes: $51.900</p>
          <p className="text-orange-500 font-bold uppercase tracking-widest text-sm mb-1" data-id="element-129">
            Hoy
          </p>
          <p className="text-4xl font-extrabold text-white mb-6" data-id="element-130">
            $19.990 <span className="text-xl text-gray-400" data-id="element-131">ARS</span>
          </p>
          <div className="max-w-xl mx-auto" data-id="element-132">
            <Button href="https://www.compradigitalya.com/cart/42853224349767:1" className="bg-gray-800 hover:bg-gray-700 border-gray-600 shadow-none" data-id="element-133">
              👉 QUIERO MI COCINA RESUELTA AHORA
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-gray-400 text-sm font-medium mb-16" data-id="element-134">
          <div className="flex items-center gap-2" data-id="element-135">
            <Lock className="w-5 h-5 text-orange-500" data-id="element-136" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-137">
            <Zap className="w-5 h-5 text-orange-500" data-id="element-138" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2" data-id="element-139">
            <Shield className="w-5 h-5 text-orange-500" data-id="element-140" /> Garantía 7 días
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-gray-500 text-sm" data-id="element-141">
          <p className="font-bold text-white mb-4 text-lg" data-id="element-142">
            COCINA RESUELTA™{' '}
            <span className="font-normal text-gray-400" data-id="element-143">
              El sistema de recetas N°1 para familias argentinas.
            </span>
          </p>
          <div className="flex justify-center gap-6 mb-6" data-id="element-144">
            <span className="flex items-center gap-2" data-id="element-145">
              🌐 www.compradigitalya.com
            </span>
            <span className="flex items-center gap-2" data-id="element-146">
              ✉️ compradigitalyaa@gmail.com
            </span>
          </div>
          <p data-id="element-147">© 2026 CompraDigitalYa — Todos los derechos reservados.</p>
        </div>
      </div>
    </section>;
};